"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ofType = void 0;

var _reduxObservable = require("redux-observable");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Type-safe wrapper for Redux-observable's ofType
 *
 * @template TPayload, TActionCreator extends ActionCreator<TPayload>
 * @param {TActionCreator extends ActionCreator<TPayload>} ac
 * @returns {Observable<ReturnType<TActionCreator>>}
 */
var ofType = function ofType() {
  for (var _len = arguments.length, ac = new Array(_len), _key = 0; _key < _len; _key++) {
    ac[_key] = arguments[_key];
  }

  return _reduxObservable.ofType.apply(void 0, _toConsumableArray(ac.map(function (actionCreator) {
    return actionCreator.getType();
  })));
};

exports.ofType = ofType;